import Dropdown from "../../Components/Fields/Dropdown";
import {
  CheckMandatory,
  DeleteRecord,
  ErrorAlert,
  GetRecords,
  saveRecord,
  SuccessAlert,
  UpdateRecord,
  URLPRIFIX,
} from "../../functions/api";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import String from "../../Components/Fields/String";
import { useStore } from "../../Components/StateProvider";
import FormView from "../../Components/Elements/FormView";
import "react-toastify/dist/ReactToastify.css";
import ListView from "../../Components/Elements/ListView";
import { getlocal } from "../../functions/localstorage";

const CategoryForm = () => {
  const { option, id } = useParams();
  const tablename = "category";
  const props = getlocal("properties");
  const setrecord = "/clientcategory/addCategory";
  const getrecord = `/clientcategory/getcategory/${id}`;
  const updaterecord = "/clientcategory/updatecategory/" + id;

  const store = useStore();
  const init = {
    categoryName: "",
    activeStatus: true,
  };

  useEffect(() => {
    // console.log("Params",param);

    store.setmodule(tablename, init);
    if (id != undefined) {
      store.setheader(option.toUpperCase() + " " + tablename);
      // store.setheader("Edit " + tablename);

      store.setprops("activeStatus", { hidden: false });
      if (option === "view") {
        store.setprops("activeStatus", { hidden: false, readonly: true });
        store.setprops("categoryName", {
          hidden: false,
          readonly: true,
          mandatory: false,
        });
      } else {
        store.setprops("activeStatus", { hidden: false, readonly: false });
        store.setprops("categoryName", {
          hidden: false,
          readonly: false,
          mandatory: false,
        });
      }

      LoadInitdata();
    } else {
      store.setheader("CREATE NEW " + tablename);
      store.setprops("activeStatus", { hidden: false, readonly: false });
      store.setprops("categoryName", {
        hidden: false,
        readonly: false,
        mandatory: true,
      });
    }
  }, [option, id]);

  function LoadInitdata() {
    GetRecords(getrecord).then((res) => {
      console.log(tablename + " Data - ", res, res.record);
      if (res.success) {
        init.categoryName = res.record.response[0].categoryName;
        init.activeStatus = res.record.response[0].activeStatus;

        init.child = {};

        if (res?.record?.projects?.length > 0) {
          var project = res?.record?.projects || [];
          project = project.map((item) => {
            if (item.type == 11) {
              item.type = "Non-Litigation";
            } else if (item.type == 12) {
              item.type = "Litigation";
            } else if (item.type == 13) {
              item.type = "TradeMark";
            }
            return { ...item };
          });
          init.child.Projects = {
            list: project,
            header: [
              ["Project Name", "projectName"],
              ["Type", "type"],
              ["Priority", "priority"],
              ["Status", "status"],
              ["ActiveStatus", "activeStatus"],
              ["Action", "ACTION"],
            ],
          };
        }
        if (res?.record?.contacts?.length > 0) {
          init.child.Contacts = {
            list: res.record.contacts,
            header: [
              ["Customer", "clientName"],
              ["E-Mail", "email"],
              ["Phone Number", "phoneno"],
              ["Film", "film_name"],
              ["Action", "ACTION"],
            ],
          };
        }
        console.log("store.reset(init);", init);

        store.reset(init);
      } else if (res.code === 401) {
        ErrorAlert(" Error Found Please contact the Admin");
      }
      // else if (res.code === 401) {
      //   store.logout();
      //   store.navTo("/login");
      // }
    });
  }

  function update() {
    store.startLoading();
    console.log(store.getrecord());
    let data = store.getrecord();
    data.modifiedBy = store.getuser().id;
    data.id = Number(id);
    if (typeof data.activeStatus === "string") {
      data.activeStatus = data.activeStatus == "true" ? true : false;
    }
    UpdateRecord(updaterecord, data).then((res) => {
      if (res.success) {
        SuccessAlert("Category Updated Successfully");
        store.stopLoading();
        store.reset(init);
        store.navback();
      } else {
        console.log("errormessage", res);
        store.stopLoading();
        ErrorAlert(
          res?.errormessage?.data ||
            "Unknown Error Found. Please contact the Admin"
        );
      }
    });
  }

  function Submit() {
    store.startLoading();
    let data = store.getrecord();
    const { Notification, ...dataWithoutNotification } = data;
    dataWithoutNotification.modifiedBy = store.getuser().id;
    dataWithoutNotification.createdBy = store.getuser().id;
    if (typeof dataWithoutNotification.activeStatus === "string") {
      dataWithoutNotification.activeStatus =
        dataWithoutNotification.activeStatus == "true" ? true : false;
    }
    // let data = store.getrecord();
    // data.modifiedBy = store.getuser().id;
    // data.createdBy = store.getuser().id;
    if (CheckMandatory(tablename, store)) {
      saveRecord(setrecord, dataWithoutNotification).then((res) => {
        console.log("Resonce of saveRecord - ", res);
        store.stopLoading();
        if (res.success) {
          SuccessAlert("Category Submitted Successfully");
          store.reset(init);
          store.navback();
        } else {
          console.log("errormessage", res);
          store.stopLoading();
          ErrorAlert(
            res?.errormessage?.response?.data?.errorMessage ||
              " Error Found Please contact the Admin"
          );
        }
      });
    }
  }
  return (
    <FormView
      actions={[
        {
          Name: "Back",
          onclick: () => {
            store.navback();
            store.reset(init);
          },
          visible: true,
        },
        {
          Name: "Edit",
          onclick: () => {
            store.navTo(`/${URLPRIFIX}/categories/edit/${id}`);
          },
          visible: option === "view" && store.getprops("update"),
        },
        {
          Name: "Add Contact",
          onclick: () => {
            store.setrecord("contact", {
              client_id: "",
              clientName: "",
              phoneno: "",
              email: "",
              category_ID: "1",
              url: "",
              activeStatus: true,
              film_id: id,
              address: "",
              child: [],
            });
            store.navTo("/" + URLPRIFIX + "/contacts/create?film_id=readonly");
          },
          type: "primary",
          visible: option === "view" && props.contact.add && id == 1,
        },
        {
          Name: "Add Project",
          onclick: () => {
            store.setrecord("nonlitigation_project", {
              projectName: "",
              projectDescription: "",
              startDate: "",
              endDate: "",
              priority: "",
              status: "Draft",
              film_id: "0",
              category_id: id,
              contact_id: "",
              activeStatus: true,
              child: [],
              attachmenturl: [],
            });
            store.navTo(
              "/" +
                URLPRIFIX +
                "/projects/create?category_id=readonly&&film_id=mandatory"
            );
          },
          type: "primary",
          visible: option === "view" && props.nonlitigation_project.add,
        },
        {
          Name: "Submit",
          onclick: Submit,
          type: "primary",
          // visible: false,
          visible: id === undefined,
        },
        {
          Name: "Update",
          onclick: update,
          type: "primary",
          // visible: false,
          visible: option === "edit" && store.getprops("update"),
        },
      ]}
    >
      <div className="grid grid-cols-2 gap-6">
        <String name="categoryName" label="Category Name :" />
        <Dropdown
          name="activeStatus"
          label="Active Status :"
          list={[
            { value: true, label: "Active" },
            { value: false, label: "InActive" },
          ]}
        />
        {option === "view" && (
          <ChildTabsView
            className="col-span-2 mt-1"
            tabsList={store.getvalue("child") || {}}
            store={store}
            LoadInitdata={LoadInitdata}
          />
        )}
      </div>
    </FormView>
  );
};

function ChildTabsView({ tabsList = {}, className = "", store, LoadInitdata }) {
  const [tabs, settabs] = useState("Projects");
  const props = getlocal("properties");

  return (
    <div className={className}>
      <ul
        className={
          className +
          " flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
        }
      >
        <li className="me-2">
          {props.nonlitigation_projects.view &&
            tabsList?.Projects?.list?.length > 0 && (
              <button
                className={
                  " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
                  ("Projects" === tabs
                    ? " bg-Ocean_Blue text-secondary "
                    : " bg-Alice_Blue ")
                }
                onClick={() => {
                  settabs("Projects");
                }}
              >
                {"Projects" +
                  (("Projects" === tabs &&
                    " - " + tabsList[tabs]?.list?.length) ||
                    "")}
              </button>
            )}
          {props.contacts.view && tabsList?.Contacts?.list?.length > 0 && (
            <button
              className={
                " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
                ("Contacts" === tabs
                  ? " bg-Ocean_Blue text-secondary "
                  : " bg-Alice_Blue ")
              }
              onClick={() => {
                settabs("Contacts");
              }}
            >
              {"Contacts" +
                (("Contacts" === tabs &&
                  " - " + tabsList[tabs]?.list?.length) ||
                  "")}
            </button>
          )}
        </li>
      </ul>

      <ListView
        Tablehead={"font-bold text-[18px]"}
        Tablerecord="pr-[10px] text-[14px] cursor-pointer "
        onclick={(index) => {
          if (tabs === "Projects") {
            if (index.type == "Non-Litigation") {
              store.navTo("/" + URLPRIFIX + "/projects/view/" + index?.id);
            } else if (index.type == "Litigation") {
              store.navTo(
                "/" + URLPRIFIX + "/litigation/projects/view/" + index?.id
              );
            } else if (index.type == "TradeMark") {
              store.navTo(
                "/" + URLPRIFIX + "/trademark/projects/view/" + index?.id
              );
            }
          }
          if (tabs === "Contacts") {
            store.navTo("/" + URLPRIFIX + "/contacts/view/" + index?.id);
          }
        }}
        ondelete={
          tabs == "Projects" && props.nonlitigation_projects.delete
            ? (item) => {
                DeleteRecord("/project/deleteproject/" + item.id, {
                  modifiedBy: store.getuser().id,
                }).then((res) => {
                  if (res.success) {
                    SuccessAlert("Deleted Successfully");
                    LoadInitdata();
                  } else {
                    store.stopLoading();
                    ErrorAlert(
                      res?.errormessage?.response.data ||
                        " Unknown Error Found Please contact the Admin"
                    );
                  }
                });
              }
            : tabs == "Contacts" && props.contacts.delete
            ? (item) => {
                DeleteRecord("/contact/deletecontacts/" + item.id, {
                  modifiedBy: store.getuser().id,
                }).then((res) => {
                  if (res.success) {
                    SuccessAlert("Deleted Successfully");
                    LoadInitdata();
                  } else {
                    store.stopLoading();
                    ErrorAlert(
                      res?.errormessage?.response.data ||
                        " Unknown Error Found Please contact the Admin"
                    );
                  }
                });
              }
            : undefined
        }
        height={"fit"}
        header={tabsList[tabs]?.header || []}
        records={tabsList[tabs]?.list || []}
      />
    </div>
  );
}

export default CategoryForm;
